<template>
  <span
    :class="{
      'group-dropdown': true,
      'inputs__group-dropdown': true,
    }"
    @click="$refs.dropdown.toggle($event)"
  >
    <span
      :class="{
        'color-box': true,
        'color-box--outlined': !colorGroup || calculateColorBrightness(colorGroup) > 240,
        'group-dropdown__color-box': true,
      }"
      :style="{ backgroundColor: colorGroup ? rgbToCssValue(colorGroup) : 'transparent' }"
    />
    <dropdown-caret :is-flipped="isOpen" class="group-dropdown__arrow" />
    <fs-popper ref="dropdown" placement="bottom" @open="isOpen = true" @close="isOpen = false">
      <fs-menu class="group-dropdown__dropdown">
        <fs-menu-select-group v-model="_localValue" :options="colorGroupsList">
          <template v-slot:icon="{ item }">
            <span
              :class="{
                'color-box': true,
                'color-box--outlined': calculateColorBrightness(item) > 240,
                'group-dropdown__color-box--list-item': true,
                'group-dropdown__color-box': true,
              }"
              :style="{ backgroundColor: rgbToCssValue(item) }"
            />
          </template>
        </fs-menu-select-group>
      </fs-menu>
    </fs-popper>
  </span>
</template>

<script>
import { calculateColorBrightness, rgbToCssValue } from '@lib/colorManagement';
import twoWayProperty from '@lib/twoWayProperty';

// Components
import FsPopper from '@components/poppers/fs-popper.vue';
import FsMenu from '@components/fs-menu/index.vue';
import FsMenuSelectGroup from '@components/fs-menu/fs-menu-select-group.vue';
import DropdownCaret from '@components/dropdown-caret.vue';

export default {
  name: 'color-group-picker',

  components: {
    DropdownCaret,
    FsMenu,
    FsMenuSelectGroup,
    FsPopper,
  },

  props: {
    // Empty for a colour without a group, until one is picked.
    modelValue: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      isOpen: false,
    };
  },

  computed: {
    _localValue: twoWayProperty('modelValue'),

    colorGroup() {
      return this.$store.colorGroups.getById(this._localValue);
    },

    colorGroupsList() {
      const others = this.$store.colorGroups.loaded.filter((c) => c.id !== this._localValue);
      return (this.colorGroup ? [this.colorGroup, ...others] : others).map((g) => ({
        ...g,
        label: g.name,
        value: g.id,
      }));
    },
  },

  methods: {
    calculateColorBrightness,
    rgbToCssValue,
  },
};
</script>

<style scoped lang="scss">
@import '@styles/variables';

// Color box
.color-box {
  width: 3rem;
  height: 2rem;
  display: inline-block;
  border-radius: 0.5rem;

  &--outlined {
    border-width: 1px;
    border-style: solid;
    border-color: $c-dark;
  }
}

// Group Dropdown --------------------------------------------------------------
.group-dropdown {
  margin-left: 2rem;
  height: 3.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    opacity: 0.75;
  }

  &__arrow {
    width: 0.9rem;
    height: 0.5rem;
    margin: 0 0.9rem;
  }

  &__dropdown {
    max-height: 25rem;
  }

  &__color-box {
    &--list-item {
      margin-right: 1.2rem;
    }
  }
}
</style>
